module.exports = __webpack_public_path__ + "static/A Buyer's Story Ashirwad Bakery_Thumbnail 02-754997d7686eb0485f87e02ce314112d.png";